// @flow

import {useEffect, useMemo, useState} from 'react';

export const readUsercentricsConsent = (): object | null => {
  const usercentricsCmp = window?.__ucCmp?.cmpController;

  if (
    usercentricsCmp &&
    // IMPLICIT = When the user didn't interact with the banner
    // EXPLICIT = When the user actively gives any type of consent (what we care about)
    usercentricsCmp.consent?.type === 'EXPLICIT' &&
    usercentricsCmp.dps?.categories
  ) {
    const categories = Object.fromEntries(
      Object.values(usercentricsCmp.dps.categories).map((category) => [
        // have to use the name shown in the ui as identifier
        category.name,
        category.state === 'ALL_ACCEPTED',
      ])
    );
    return {
      personalization: categories.Personalisierung,
      retargeting: categories.Retargeting,
      statistic: categories.Statistik,
      technicalNecessary: categories.Notwendig ?? true,
    };
  }

  return null;
};

export const useUsercentricsConsent = (): object => {
  const [consentStatus, setConsentStatus] = useState(() =>
    readUsercentricsConsent()
  );

  useEffect(() => {
    let intervalId = 0;
    let timeoutId = 0;
    if (!consentStatus) {
      intervalId = window.setInterval(() => {
        const currentStatus = readUsercentricsConsent();
        if (currentStatus) {
          setConsentStatus(currentStatus);
          window.clearInterval(intervalId);
        }
      }, 250);
      timeoutId = window.setTimeout(() => {
        window.clearInterval(intervalId);
      }, 60);
    }
    return () => {
      window.clearInterval(intervalId);
      window.clearTimeout(timeoutId);
    };
  }, [consentStatus]);

  const consentValue = useMemo(
    () => ({
      consentStatus,
    }),
    [consentStatus]
  );

  return consentValue;
};

export const injectUsercentrics = (settingsId: string) => {
  const script = document.createElement('script');
  script.src = 'https://web.cmp.usercentrics.eu/ui/loader.js';
  script.async = true;
  script.id = 'usercentrics-cmp';
  script.dataset.settingsId = settingsId;
  if (document.head) {
    document.head.insertBefore(script, document.head.childNodes[0]);
  }
};
